import {NOT_UPLOADED_YET} from 'constants/ipfs-constants.js';

/**
 * Caches the colored waveforms shown in the sound details view
 * so we don't waste computation, and slow down the program.
*/

class WaveformCache {
    constructor(width, height) {
        this.index = 0;
        this.width = width;
        this.height = height;
        this.idToWaveform = {};
        this.idToBasicWaveform = {};
        this.reversedIdToWaveform = {};
    }

    getBasicWaveform(id, buffer, cacheResults=id !== NOT_UPLOADED_YET) {
        return new Promise((resolve, reject) => {
            if (cacheResults && id in this.idToBasicWaveform) {
                resolve(this.idToBasicWaveform[id]);
                return;
            }
            this.computeBasicWaveform(buffer).then(
                waveform => {
                    if (cacheResults) {
                        this.idToBasicWaveform[id] = waveform;
                    }
                    resolve(waveform);
                });
        });
    }

    getWaveform(id, buffer, cacheResults=id !== NOT_UPLOADED_YET, pointWidth=3, height=this.height) {
        return new Promise((resolve, reject) => {
            /*
            if (cacheResults && id in this.idToWaveform) {
                resolve(this.idToWaveform[id]);
                return;
            }
            */
            this.computeWaveformPoints(buffer, 0, [], (waveform) => {
                if (cacheResults) {
                    this.idToWaveform[id] = waveform;
                }
                resolve(waveform);
            }, pointWidth, height);
        });
    }

    getReversedWaveform(id, buffer) {
        return new Promise((resolve, reject) => {
            if (id in this.reversedIdToWaveform) {
                resolve(this.reversedIdToWaveform[id]);
                return;
            }
            this.computeWaveformPoints(buffer, 0, [], (waveform) => {
                this.reversedIdToWaveform[id] = waveform;
                resolve(waveform);
            });
        });
    }

    async computeWaveformPoints(buffer, chunkNumber, prevList, callback, pointWidth=1, height) {
        pointWidth = 1;
        const chunkSize = this.width;
        if ((chunkNumber + 1)*chunkSize > this.width) {
            callback([]);
            return;
        } 

        var step = Math.floor(buffer.length / this.width);
        var channel = buffer.getChannelData(0);
        channel = channel.subarray(chunkSize*chunkNumber*step, chunkSize*(chunkNumber + 1)*step);
        let p = window.api.create_buffer(channel.length);
        var maxWidth = Math.min((chunkNumber + 1) * chunkSize, this.width);
        window.Module.HEAPF32.set(channel, p >> 2);
        window.api.getColoredWaveform(p, chunkSize, height, channel.length, step, chunkSize*chunkNumber, pointWidth);
        const resultPointer = window.api.get_result_pointer();
        const resultView = new Uint16Array(window.Module.HEAP16.buffer, resultPointer, chunkSize*7/pointWidth);
        let list = [];

        for (var i=0; i < chunkSize*7/pointWidth ; i+=7) {
            let rgb = [resultView[i+4], resultView[i+5], resultView[i+6]];
            list.push({x:resultView[i], y: resultView[i+1], width: resultView[i+2], height: resultView[i+3], rgb: rgb});
        }
        /*
        self.state.pts = prevList.concat(list);
        self.setState(self.state);
        */

        var self = this;
        window.api.destroy_buffer(p);
        setTimeout(function () {
            self.computeWaveformPoints(buffer, chunkNumber + 1, prevList.concat(list), function (ret) {
                callback(list.concat(ret));
            });
        }, 2);
   };


    async computeBasicWaveform(buffer) {
        this.index++;
        let index = this.index;
        var step = Math.floor(buffer.length / this.width);
        var channel = buffer.getChannelData(0);
        let p = window.api.create_buffer(channel.length);
        var maxWidth = this.width;
        window.Module.HEAPF32.set(channel, p >> 2);
        window.api.getWaveform(p, parseInt(this.width), parseInt(this.height), channel.length, step);
        const resultPointer = window.api.get_result_pointer();
        const resultView = new Uint16Array(window.Module.HEAP16.buffer, resultPointer, this.width*3);
        let list = [];

        if (index < this.index) {
            return undefined;
        }

        let x =0;
        for (var i=0; i < this.width*3 ; i+=3) {
            list.push({x:x, y: resultView[i+1], rmsY: resultView[i+2]});
            x++;
        }
        window.api.destroy_buffer(p);
        return list;
    }
}

export default WaveformCache;
